export const cleanPhoneNumber = (phoneNumber: string): string => {
  const startsWithPlus = phoneNumber.startsWith('+');
  let cleaned = phoneNumber.replace(/\D/g, '');
  if (startsWithPlus) {
    cleaned = '+' + cleaned.replace(/^\+/, '');
  }

  return cleaned;
};

export const cleanCountryCode = (
  phoneNumber: string,
  countryCode: string = '+1'
): string => {
  return phoneNumber.startsWith(countryCode)
    ? phoneNumber.replace(countryCode, '')
    : phoneNumber;
};
